import { FC, useCallback, useEffect, useState } from 'react'
import { Trans } from 'react-i18next'
import { useTranslation } from '../../../../hooks/useTranslation'
import IMAGE_RIGHT_1 from '../assets/img/reason_1.png'
import IMAGE_RIGHT_1_VN from '../assets/img/reason_1_vn.png'
import IMAGE_RIGHT_2 from '../assets/img/reason_2.png'
import IMAGE_RIGHT_2_VN from '../assets/img/reason_2_vn.png'
import IMAGE_RIGHT_3 from '../assets/img/reason_3.png'
import IMAGE_RIGHT_3_VN from '../assets/img/reason_3_vn.png'
import Image from 'next/image'
import { clearInterval } from 'timers'

const IMAGE_1 = (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
    <rect x="10.1445" width="39.1918" height="39.1918" rx="5.8062" transform="rotate(15 10.1445 0)" fill="#9CA3AF" />
    <g opacity="0.4">
      <rect y="9" width="39.1918" height="39.1918" rx="5.8062" fill="#9CA3AF" />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 23C26.3431 23 25 21.6569 25 20C25 19.4601 25.1426 18.9535 25.3922 18.5159C25.0988 18.4551 24.7898 18.4091 24.4635 18.3737C23.3214 18.25 21.8818 18.25 20.0452 18.25H19.9548C18.1182 18.25 16.6786 18.25 15.5365 18.3737C14.3709 18.5 13.4266 18.7623 12.6202 19.3482C12.1321 19.7028 11.7028 20.1321 11.3482 20.6202C10.7623 21.4266 10.5 22.3709 10.3737 23.5365C10.25 24.6786 10.25 26.1182 10.25 27.9547V28.0452C10.25 29.8818 10.25 31.3214 10.3737 32.4635C10.5 33.6291 10.7623 34.5734 11.3482 35.3798C11.7028 35.8679 12.1321 36.2972 12.6202 36.6518C13.4266 37.2377 14.3709 37.5 15.5365 37.6263C16.6786 37.75 18.1182 37.75 19.9547 37.75H20.0453C21.8818 37.75 23.3214 37.75 24.4635 37.6263C25.6291 37.5 26.5734 37.2377 27.3798 36.6518C27.8679 36.2972 28.2972 35.8679 28.6518 35.3798C29.2377 34.5734 29.5 33.6291 29.6263 32.4635C29.75 31.3214 29.75 29.8818 29.75 28.0453V27.9547C29.75 26.1182 29.75 24.6786 29.6263 23.5365C29.5909 23.2102 29.5449 22.9012 29.4841 22.6078C29.0465 22.8574 28.5399 23 28 23ZM25.3303 24.4695C25.7022 24.6519 25.8558 25.1013 25.6734 25.4732L24.213 28.4502C23.1904 30.5348 20.185 30.433 19.3058 28.284C18.9167 27.3327 17.5863 27.2876 17.1337 28.2104L15.6734 31.1874C15.4909 31.5593 15.0416 31.7129 14.6697 31.5305C14.2978 31.3481 14.1442 30.8987 14.3266 30.5268L15.787 27.5498C16.8096 25.4652 19.815 25.567 20.6942 27.716C21.0833 28.6673 22.4137 28.7124 22.8663 27.7896L24.3266 24.8126C24.5091 24.4407 24.9584 24.2871 25.3303 24.4695Z"
      fill="white"
    />
    <path
      d="M26 20C26 21.1046 26.8954 22 28 22C29.1046 22 30 21.1046 30 20C30 18.8954 29.1046 18 28 18C26.8954 18 26 18.8954 26 20Z"
      fill="white"
    />
  </svg>
)
const IMAGE_1_ACTIVE = (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none">
    <rect x="13.5254" width="52.2558" height="52.2558" rx="7.7416" transform="rotate(15 13.5254 0)" fill="#9D98FF" />
    <rect opacity="0.4" y="12" width="52.2558" height="52.2558" rx="7.7416" fill="#563EC3" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.6667 31.3332C34.4575 31.3332 32.6667 29.5423 32.6667 27.3332C32.6667 26.6133 32.8568 25.9379 33.1896 25.3543C32.7984 25.2733 32.3864 25.2119 31.9514 25.1648C30.4285 24.9998 28.509 24.9998 26.0603 24.9998H25.9397C23.491 24.9998 21.5715 24.9998 20.0486 25.1648C18.4946 25.3332 17.2354 25.6829 16.1603 26.464C15.5095 26.9369 14.9371 27.5093 14.4642 28.1602C13.6831 29.2352 13.3333 30.4944 13.165 32.0485C13 33.5713 13 35.4908 13 37.9395V38.0602C13 40.5089 13 42.4284 13.165 43.9512C13.3333 45.5053 13.6831 46.7644 14.4642 47.8395C14.9371 48.4904 15.5095 49.0628 16.1603 49.5356C17.2354 50.3167 18.4946 50.6665 20.0486 50.8349C21.5715 50.9999 23.491 50.9998 25.9396 50.9998H26.0605C28.5091 50.9998 30.4285 50.9999 31.9514 50.8349C33.5054 50.6665 34.7646 50.3167 35.8397 49.5356C36.4905 49.0628 37.0629 48.4904 37.5358 47.8395C38.3169 46.7644 38.6667 45.5053 38.835 43.9512C39 42.4284 39 40.5089 39 38.0602V37.9394C39 35.4907 39 33.5713 38.835 32.0485C38.7879 31.6134 38.7265 31.2015 38.6455 30.8102C38.062 31.143 37.3865 31.3332 36.6667 31.3332ZM33.1071 33.2925C33.6029 33.5357 33.8077 34.1349 33.5645 34.6307L31.6174 38.6001C30.2539 41.3796 26.2467 41.2439 25.0745 38.3785C24.5556 37.1101 22.7818 37.05 22.1782 38.2804L20.2311 42.2498C19.9879 42.7456 19.3888 42.9504 18.8929 42.7072C18.3971 42.4639 18.1923 41.8648 18.4355 41.369L20.3826 37.3996C21.7461 34.6201 25.7533 34.7558 26.9255 37.6212C27.4444 38.8896 29.2182 38.9496 29.8218 37.7193L31.7689 33.7499C32.0121 33.2541 32.6112 33.0493 33.1071 33.2925Z"
      fill="white"
    />
    <path
      d="M34 27.3332C34 28.8059 35.1939 29.9998 36.6667 29.9998C38.1394 29.9998 39.3333 28.8059 39.3333 27.3332C39.3333 25.8604 38.1394 24.6665 36.6667 24.6665C35.1939 24.6665 34 25.8604 34 27.3332Z"
      fill="white"
    />
  </svg>
)

const IMAGE_2 = (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
    <rect x="10.1445" width="39.1918" height="39.1918" rx="5.8062" transform="rotate(15 10.1445 0)" fill="#9CA3AF" />
    <g opacity="0.4">
      <rect y="9" width="39.1918" height="39.1918" rx="5.8062" fill="#9CA3AF" />
    </g>
    <path
      d="M26.5 23.75C26.5 21.6789 24.8211 20 22.75 20C20.6789 20 19 21.6789 19 23.75C19 25.8211 20.6789 27.5 22.75 27.5C24.8211 27.5 26.5 25.8211 26.5 23.75Z"
      fill="white"
    />
    <path
      d="M19.4006 20.3819C18.5355 21.2422 18 22.4336 18 23.75C18 25.0664 18.5355 26.2578 19.4006 27.1181C18.9026 27.3627 18.3423 27.5 17.75 27.5C15.6789 27.5 14 25.8211 14 23.75C14 21.6789 15.6789 20 17.75 20C18.3423 20 18.9026 20.1373 19.4006 20.3819Z"
      fill="white"
    />
    <path
      d="M29.5 32.75C29.5 30.6789 27.8211 29 25.75 29H19.75C17.6789 29 16 30.6789 16 32.75C16 34.8211 17.6789 36.5 19.75 36.5H25.75C27.8211 36.5 29.5 34.8211 29.5 32.75Z"
      fill="white"
    />
    <path
      d="M15 32.75C15 33.7749 15.3246 34.7239 15.8766 35.5H14.75C12.6789 35.5 11 33.8211 11 31.75C11 29.6789 12.6789 28 14.75 28H19.75C17.1266 28 15 30.1266 15 32.75Z"
      fill="white"
    />
  </svg>
)
const IMAGE_2_ACTIVE = (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none">
    <rect x="13.5254" width="52.2558" height="52.2558" rx="7.7416" transform="rotate(15 13.5254 0)" fill="#9D98FF" />
    <rect opacity="0.4" y="12" width="52.2558" height="52.2558" rx="7.7416" fill="#563EC3" />
    <path
      d="M34.666 32.3335C34.666 29.5721 32.4274 27.3335 29.666 27.3335C26.9046 27.3335 24.666 29.5721 24.666 32.3335C24.666 35.0949 26.9046 37.3335 29.666 37.3335C32.4274 37.3335 34.666 35.0949 34.666 32.3335Z"
      fill="white"
    />
    <path
      d="M25.2002 27.8427C24.0467 28.9897 23.3327 30.5782 23.3327 32.3335C23.3327 34.0888 24.0467 35.6772 25.2002 36.8243C24.5361 37.1504 23.7891 37.3335 22.9993 37.3335C20.2379 37.3335 17.9993 35.0949 17.9993 32.3335C17.9993 29.5721 20.2379 27.3335 22.9993 27.3335C23.7891 27.3335 24.5361 27.5166 25.2002 27.8427Z"
      fill="white"
    />
    <path
      d="M38.666 44.3335C38.666 41.5721 36.4274 39.3335 33.666 39.3335H25.666C22.9046 39.3335 20.666 41.5721 20.666 44.3335C20.666 47.0949 22.9046 49.3335 25.666 49.3335H33.666C36.4274 49.3335 38.666 47.0949 38.666 44.3335Z"
      fill="white"
    />
    <path
      d="M19.3327 44.3335C19.3327 45.7 19.7655 46.9654 20.5014 48.0002H18.9993C16.2379 48.0002 13.9993 45.7616 13.9993 43.0002C13.9993 40.2387 16.2379 38.0002 18.9993 38.0002H25.666C22.1682 38.0002 19.3327 40.8357 19.3327 44.3335Z"
      fill="white"
    />
  </svg>
)

const IMAGE_3 = (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
    <rect x="10.1445" width="39.1918" height="39.1918" rx="5.8062" transform="rotate(15 10.1445 0)" fill="#9CA3AF" />
    <g opacity="0.4">
      <rect y="9" width="39.1918" height="39.1918" rx="5.8062" fill="#9CA3AF" />
    </g>
    <path
      d="M26 29.4988C27.1046 29.4988 28.0221 30.405 27.7787 31.4824C27.5367 32.5534 27.0995 33.5766 26.4832 34.4989C25.4943 35.979 24.0887 37.1325 22.4442 37.8137C20.7996 38.4949 18.99 38.6731 17.2442 38.3259C15.4984 37.9786 13.8947 37.1214 12.636 35.8628C11.3774 34.6041 10.5202 33.0004 10.1729 31.2546C9.82567 29.5088 10.0039 27.6992 10.6851 26.0547C11.3663 24.4101 12.5198 23.0045 13.9999 22.0156C14.9222 21.3993 15.9454 20.9621 17.0164 20.7201C18.0938 20.4767 19 21.3942 19 22.4988V24.4988C19 27.2602 21.2386 29.4988 24 29.4988H26Z"
      fill="white"
    />
    <path
      d="M22 21.0331C22 19.0811 23.6408 17.4369 25.4442 18.1839C26.5361 18.6362 27.5282 19.2991 28.364 20.1348C29.1997 20.9706 29.8626 21.9627 30.3149 23.0547C31.0619 24.858 29.4177 26.4988 27.4657 26.4988H26.5C24.0147 26.4988 22 24.4841 22 21.9988V21.0331Z"
      fill="white"
    />
  </svg>
)
const IMAGE_3_ACTIVE = (
  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="65" viewBox="0 0 64 65" fill="none">
    <rect x="13.5254" width="52.2558" height="52.2558" rx="7.7416" transform="rotate(15 13.5254 0)" fill="#9D98FF" />
    <rect opacity="0.4" y="12" width="52.2558" height="52.2558" rx="7.7416" fill="#563EC3" />
    <path
      d="M34.0003 39.9982C35.4731 39.9982 36.6965 41.2065 36.3719 42.6431C36.0492 44.071 35.4663 45.4354 34.6446 46.6651C33.3261 48.6385 31.4519 50.1765 29.2592 51.0848C27.0665 51.993 24.6537 52.2307 22.3259 51.7677C19.9981 51.3046 17.8599 50.1618 16.1817 48.4835C14.5035 46.8053 13.3606 44.6671 12.8976 42.3393C12.4346 40.0116 12.6722 37.5988 13.5804 35.406C14.4887 33.2133 16.0268 31.3392 18.0002 30.0206C19.2299 29.1989 20.5942 28.616 22.0222 28.2933C23.4587 27.9687 24.667 29.1921 24.667 30.6649V33.3316C24.667 37.0135 27.6518 39.9982 31.3337 39.9982H34.0003Z"
      fill="white"
    />
    <path
      d="M28.667 28.7106C28.667 26.108 30.8547 23.9157 33.2592 24.9117C34.7151 25.5147 36.038 26.3987 37.1523 27.513C38.2666 28.6273 39.1505 29.9501 39.7536 31.406C40.7495 33.8105 38.5572 35.9982 35.9546 35.9982H34.667C31.3533 35.9982 28.667 33.3119 28.667 29.9982V28.7106Z"
      fill="white"
    />
  </svg>
)

const SectionReasonHH: FC = () => {
  const { translate, currentLanguage } = useTranslation()
  const [activeImage, setActiveImage] = useState(1)

  const onChangeActive = useCallback((activePos: number) => {
    setActiveImage(activePos)
  }, [])

  return (
    <div className="reason">
      <div className="wrapper-container">
        <div className="heading">
          <Trans i18nKey={'page_employer_headhunt_service:reason_title'}>
            <span className="high-light" />
          </Trans>
        </div>
        <div className="subtitle">{translate('page_employer_headhunt_service:reason_subtitle')}</div>
        <div className="reason-content">
          <div className="reason-line" />
          <div className="reason-left-col">
            <div onClick={() => onChangeActive(1)} className={`reason-title ${activeImage === 1 ? 'active' : ''}`}>
              <div>{activeImage === 1 ? IMAGE_1_ACTIVE : IMAGE_1}</div>
              <div>
                <div className="title">{translate('page_employer_headhunt_service:smart_track')}</div>
                <div className="sub-title">{translate('page_employer_headhunt_service:smart_track_des')}</div>
                <div className="d-mobile">
                  {activeImage === 1 && (
                    <Image
                      src={currentLanguage === 'en' ? IMAGE_RIGHT_1 : IMAGE_RIGHT_1_VN}
                      placeholder="blur"
                      alt="img_right"
                      width={640}
                      height={507}
                    />
                  )}
                </div>
              </div>
            </div>
            <div onClick={() => onChangeActive(2)} className={`reason-title ${activeImage === 2 ? 'active' : ''}`}>
              <div>{activeImage === 2 ? IMAGE_2_ACTIVE : IMAGE_2}</div>
              <div>
                <div className="title">{translate('page_employer_headhunt_service:smart_frontier')}</div>
                <div className="sub-title">{translate('page_employer_headhunt_service:smart_frontier_des')}</div>
                <div className="d-mobile">
                  {activeImage === 2 && (
                    <Image
                      src={currentLanguage === 'en' ? IMAGE_RIGHT_2 : IMAGE_RIGHT_2_VN}
                      placeholder="blur"
                      alt="img_right"
                      width={640}
                      height={507}
                    />
                  )}
                </div>
              </div>
            </div>
            <div onClick={() => onChangeActive(3)} className={`reason-title ${activeImage === 3 ? 'active' : ''}`}>
              <div>{activeImage === 3 ? IMAGE_3_ACTIVE : IMAGE_3}</div>
              <div>
                <div className="title">{translate('page_employer_headhunt_service:smart_finance')}</div>
                <div className="sub-title">{translate('page_employer_headhunt_service:smart_finance_des')}</div>
                <div className="d-mobile">
                  {activeImage === 3 && (
                    <Image
                      src={currentLanguage === 'en' ? IMAGE_RIGHT_3 : IMAGE_RIGHT_3_VN}
                      placeholder="blur"
                      alt="img_right"
                      width={640}
                      height={507}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="d-desktop">
            {activeImage === 1 && (
              <Image
                src={currentLanguage === 'en' ? IMAGE_RIGHT_1 : IMAGE_RIGHT_1_VN}
                placeholder="blur"
                alt="img_right"
                width={640}
                height={507}
              />
            )}
            {activeImage === 2 && (
              <Image
                src={currentLanguage === 'en' ? IMAGE_RIGHT_2 : IMAGE_RIGHT_2_VN}
                placeholder="blur"
                alt="img_right"
                width={640}
                height={507}
              />
            )}
            {activeImage === 3 && (
              <Image
                src={currentLanguage === 'en' ? IMAGE_RIGHT_3 : IMAGE_RIGHT_3_VN}
                placeholder="blur"
                alt="img_right"
                width={640}
                height={507}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SectionReasonHH
